import { ACT_USR_CHANGE } from "./ActionTypes";
import UserService from "../provider/user/UserService";
import { loading } from "./AppActions";
import MediaService from "../provider/media/MediaService";
import moment from "moment";
/*** ACTIONS USERS ******/

export function actionGetUsers(filter,order, limit, succesCallback, errorCallback) {
    return (dispatch, getStore) => {
				loading(true)(dispatch, getStore)
        UserService.getUsers(getStore().app.app, filter, order,limit).then((response) => {
            dispatch({
                type:ACT_USR_CHANGE,
                props: {userList:response} // response con formato {items:[], size:0}
						})
            succesCallback&&succesCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };}

export function actionGetUsersByReg(filter, succesCallback, errorCallback) {
  return (dispatch, getStore) => {

      // loading(true)(dispatch, getStore)
      UserService.getUsersByReg(getStore().app.app, filter).then((response) => {
          // dispatch({
          //     type:ACT_USR_CHANGE,
          //     props: {userList:response}
          // })
          succesCallback&&succesCallback(response)
      }).catch(errorCallback)
      // .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionGetUsersByEmailOrDU(
  usersDU,
  usersEmail,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    UserService.getUsersByEmailOrDU(getStore().app.app, usersDU, usersEmail)
      .then((response) => {
        // dispatch({
        //   type:ACT_USR_CHANGE,
        //   props: {user:response}
        // })
        succesCallback && succesCallback(response);
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionGetUsersFromExcel(file, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    MediaService.uploadFile(file, "temp", "excel")
      .then((res) => {
        loading(true)(dispatch, getStore);
        UserService.getUsersFromStorage(res.path, res.filename)
          .then((response) => {
            console.log("RESPONSE", response);
            successCallback(response);
          })
          .finally(() => {
            MediaService.deleteFile(res.path);
            loading(false)(dispatch, getStore);
          });
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionSaveUser(user, successCallback, errorCallback) {
  // if (process.env.REACT_APP_HAS_BIRTHDATE_MIGRATED) {
  //   const { proBirthDate } = user;
  //   if (proBirthDate) {
  //     // console.log("actionSaveUser proBirthDate",proBirthDate, proBirthDate._seconds)
  //     // const { _seconds } = proBirthDate;
  //     console.log("actionSaveUser proBirthDate _seconds",proBirthDate)
  //     user.proBirthDate = moment.unix(proBirthDate).toDate();
  //   }
  // }

  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    UserService.saveUser(getStore().app.app, user)
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}
export function actionTransferPoints(
  points,
  dni,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    UserService.transferPoints(getStore().app.app, points,dni)
      .then((response) => {
        succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionDeleteUser(user, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    UserService.deleteUser(getStore().app.app, user.id)
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionAddTagsToUsers(
  tags,
  allUsersSelected,
  users,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    UserService.addTagsToUsers(getStore().app.app, tags, allUsersSelected, users)
      .then((response) => {
        succesCallback && succesCallback(response);
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionSendNotification(
  user,
  notification,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    if (notification.image && notification.image != {}) {
      MediaService.uploadFile(notification.image, "temp", "image")
        .then((res) => {
          notification.image = res.downloadURL;
          UserService.sendNotification(getStore().app.app, user, notification)
            .then((response) => {
              successCallback();
            })
            .catch(errorCallback)
            .finally(() => {
              MediaService.deleteFile(res.path);
            });
        })
        .catch(errorCallback)
        .finally(() => {
          loading(false)(dispatch, getStore);
        });
    } else {
      UserService.sendNotification(getStore().app.app, user, notification)
        .then((response) => {
          successCallback();
        })
        .catch(errorCallback)
        .finally(() => {
          loading(false)(dispatch, getStore);
        });
    }
  };
}
/****** FIN ACTION USERS +**********/



// WEBPACK FOOTER //
// ./src/actions/UserActions.js